import React from 'react';

const Checkbox = (props) => (
    <div className="form-check">
        <input
            type={props.type}
            className="form-check-input"
            value={props.value}
            id={props._id}
            onChange={props.onChange}
        	checked={props.checked}
        />
         <label className="form-check-label" htmlFor={props._id} >{props.label}</label>
        {props.error &&
            <div className="invalid-feedback" >
              { props.errorMessage ?  props.errorMessage : `Le champ ${props.label} est obligatoire` }
            </div>
        }
    </div>
)

export default Checkbox;


// WEBPACK FOOTER //
// ./src/components/Common/Checkbox.js